





























import {
  Vue,
  Component
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import LoadingSpinner from "@/shared/components/ui/LoadingSpinner.vue";
import { useBillingStore } from "@/shared/store/billing";

@Component({
  components: {
    Button,
    LoadingSpinner
  }
})
export default class AdminBillingDetail extends Vue {

  billingStore = useBillingStore();

  mounted () {
    this.billingStore.resetBilling();
    if (!this.billingStore.getMonthlyBillingPeriodsLoaded) {
      this.billingStore.loadMonthlyBillingPeriods();
    }
  }

  async getParameters (event) {
    if (!isNaN(event.target.value)) {
      try {
        this.billingStore.setBillingPeriodId({
          billingPeriodId: event.target.value,
          reportName: event.target.selectedOptions[0].label
        });
      } catch (err) {
        window.console.log("Error loading billing period: " + err);
      }
    } else {
      this.billingStore.resetBillingPeriod();
    }
  }

  hasMonthlyBillingPeriods () {
    return this.billingStore.getMonthlyBillingPeriodsLoaded
        && this.billingStore.getMonthlyBillingPeriods.length > 0;
  }

  downloadCsv (e) {
    this.billingStore.downloadReport({
      periodId: this.billingStore.getSelectedBillingPeriod,
      periodName: this.billingStore.getSelectedBillingName
    });
  }
}
